import { render } from "./PrescriberTwoFactorEnableAuth.vue?vue&type=template&id=2f9dae0c"
import script from "./PrescriberTwoFactorEnableAuth.vue?vue&type=script&lang=js"
export * from "./PrescriberTwoFactorEnableAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__